module.exports = __webpack_public_path__ + "media/images/icons/document-fe2676de5a749db8db2ab19184eb20cd.svg";